export const socialPlatforms = {
  telegram: 'telegram',
  twitter: 'twitter',
  discord: 'discord',
} as const;
